import script from "./LoginDesktop.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginDesktop.vue?vue&type=script&setup=true&lang=js"

import "./LoginDesktop.vue?vue&type=style&index=0&id=6deaa2a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6deaa2a8"]])

export default __exports__